import format from 'date-fns/format';
import CustomFieldTypes from '@/constants/customFields/CustomFieldTypes';
import translate from '@/lib/intl/translate';
import { dateStringToDate } from '../dates';

const renderCustomFieldValue = (
  value: boolean | string | string[] | undefined,
  fieldType: CustomFieldTypes,
) => {
  if (typeof value === 'undefined' && fieldType !== CustomFieldTypes.CHECKBOX)
    return null;
  if (typeof value === 'boolean' || fieldType === CustomFieldTypes.CHECKBOX)
    return `${value ? translate('YES') : translate('NO')}`;
  if (Array.isArray(value) && value.length > 0) return value.join(', ');
  if (typeof value === 'string' && fieldType === CustomFieldTypes.DATE_PICKER) {
    return `${format(dateStringToDate(value), 'PP')}`;
  }
  return `${value}`;
};

export default renderCustomFieldValue;
